// ─── APPOINTMENT SOURCE ───────────────────────────────────────────────────────
// Appointments come from the MintMobile admin API, fetched through our own
// Vercel serverless proxy at /api/appointments (see api/appointments.js). The
// proxy holds the admin credentials server-side and returns a clean list:
//   { id, date, time, customer, address, service, status }
//
// Returns [] on any error (e.g. proxy not yet configured, or running under the
// local CRA dev server where /api functions don't exist) so the Assignments
// screen still works — it just shows no appointments to assign.

export async function fetchAppointments(dateISO) {
  try {
    const res = await fetch(`/api/appointments?date=${encodeURIComponent(dateISO)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
}
